import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8dcac98"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "50",
  cy: "50",
  r: "25"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Loader',
  setup(__props) {

const loaderClassName = "loader";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(loaderClassName)
  }, [
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(`${loaderClassName}__icon`),
      height: "100",
      width: "100"
    }, _hoisted_2, 2))
  ]))
}
}

})